

var _index = require('xo-return-to-merchant/dist/index');

var _index2 = require('xo-models/src/checkout/index');

define(['squid/index', 'text!./template.html', './opinionlab', './footerMap', 'xo-ui-components/src/modal/directive', 'xo-ui-components/src/escape-hatch/escapeHatch/directive', 'xo-device-info/dist/index', 'xo-form-components/src/language-options/directive', 'xo-models/src/user/index', 'xo-models/src/auth/index'], function (squid, template, opinionlab, footerMap) {
    squid.module('xo-footer.directive', ['squid', 'xo-modal.directive', 'xo-escape-hatch.escapeHatch.directive', 'xo-device-info', 'xo-language-options.directive', 'xomodel.user']).directive('xoFooter', function () {
        return {
            template: template,
            restrict: 'EA',
            scope: {
                token: '=',
                escapeHatchIncontext: '=',
                cancel: '@',
                merchant: '@',
                languageSwitch: '=?',
                showVenmoLegalLinks: '='
            },
            controller: function controller($scope, $populate, $rootScope, $util, $integration, $locale, $window, $DeviceInfo, $feature, $config, $state, $CheckoutInputDataModel, $AuthModel) {
                $scope.isIFrame = $util.isIFrame();
                if ($scope.escapeHatchIncontext) {
                    $scope.showEscapeHatch = $scope.isIFrame;
                }
                $scope.locale = $locale;
                $scope.proxSignUpFlow = $CheckoutInputDataModel.instance($scope.token).isEbayTxn();
                $scope.year = new Date().getFullYear();

                $scope.isApac = function () {
                    return $config.apacCountries && $config.apacCountries.indexOf($scope.locale.country) > -1;
                };

                // Determine if country belongs to a region to serve correct footer links
                var getRegion = function getRegion(country) {
                    var regions = $config.regions;
                    for (var region in regions) {
                        if (regions[region].indexOf(country) > -1) {
                            return region;
                        }
                    }
                    return false;
                };

                function isDESecondButtonFlow() {
                    return $scope.locale.country === 'DE' && $scope.checkoutAppData && $scope.checkoutAppData.is_second_button_txn;
                }

                $scope.footerLinks = function () {
                    if ($scope.isApac()) {
                        return footerMap.APAC;
                    }

                    // It is a product requirement that for the DE CYCO page, Hermes only show the footer links
                    // that were available in Aries
                    if (isDESecondButtonFlow()) {
                        return footerMap['DESecondButton'];
                    }

                    return footerMap[$scope.locale.country] || footerMap[getRegion($scope.locale.country)] || footerMap.DEFAULT;
                };

                $scope.showPolicyInfo = function () {
                    return $scope.isApac() || $scope.locale.country === 'AU';
                };

                $scope.cancelRedirect = function ($event) {
                    $event.preventDefault();

                    var cancelUri = $scope.cancel;
                    var redirectUri;

                    // "redirect_uri" as a query param overrides the cancel url in the checkout session
                    if ($integration.getConfig('REDIRECT_QUERY_PARAM')) {
                        redirectUri = $util.param('redirect_uri');

                        cancelUri = $util.buildURL(redirectUri, {
                            opType: 'cancel',
                            return_uri: $scope.cancel,
                            token: $scope.token
                        });
                    }

                    _index.$ReturnToMerchant.goTo(cancelUri);
                };

                $scope.isIndiaLegalEntity = function () {
                    // for PayPal India domestic launch legal entity should be 84
                    // update footer with indian policy for this case
                    return $scope.auth && $scope.auth.logged_in && $scope.auth.legalEntity === 84 || $scope.locale.country === 'IN';
                };

                if ($scope.token) {
                    $populate($scope, {
                        checkoutAppData: _index2.$CheckoutAppDataModel.instance($scope.token),
                        checkoutPayee: _index2.$CheckoutPayeeModel.instance($scope.token),
                        auth: $AuthModel.instance()
                    }).then(function () {
                        var merchant = $scope.checkoutAppData.merchant;

                        var payee = $scope.checkoutPayee;

                        if (payee && payee.merchant && payee.merchant.id) {
                            var hcl = $config.hideCancelLinkForMerchant;

                            var shouldHide = hcl && hcl.indexOf(payee.merchant.id) !== -1;
                            if (shouldHide) {
                                $scope.hideCancel = true;
                            }
                        }
                        $scope.cancel = $scope.checkoutAppData.urls.cancel_url;
                        $scope.merchant = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;
                    });
                }

                var cancelShowModal = $rootScope.$on('showModal', function (event, config) {
                    $scope.popupUrl = config && config.popupUrl;
                    $scope.show = true;
                    $scope.$digest(); // eslint-disable-line angular/ng_no_digest
                });

                $scope.$on('$destroy', cancelShowModal);

                $scope.showOL = function showOL(event) {
                    event.preventDefault();

                    var placeholder = 'main:ec:hermes';
                    var page = $state.current.get('trackingData.buzname.fullpage.pagename2', 'unknown').replace('%', placeholder);

                    var data = {
                        opVars: {
                            rlogId: $window.meta.rlogId || '',
                            page: page || window.location.hash,
                            csci: 'Unknown',
                            calc: $window.meta.correlationId,
                            custId: 'Unknown',
                            merchantId: 'Unknown',
                            token: $scope.token || 'Unknown'
                        },
                        locale: {
                            country: $locale.country,
                            languageCode: $locale.lang + '_' + $locale.country
                        }
                    };

                    opinionlab(data);
                };

                $scope.showFeedback = function () {
                    return !$DeviceInfo.isDevice() && !isDESecondButtonFlow();
                };

                $scope.hideReturnCancelUrl = function () {
                    return !$scope.cancel || $state.current && $state.current.name === 'checkout.done';
                };

                $scope.showVenmoLinks = function () {
                    // if on payWithSelection State, always show it, else we choose whatever 'checkout' directive says.
                    if ($state.current && $state.current.name === 'checkout.payWithSelection') {
                        return true;
                    }
                    return !!$scope.showVenmoLegalLinks;
                };

                $scope.showPaypalLinks = function () {
                    // will force Paypal Links if on payWithSelection state. Hide paypal links if we explicitly request venmo Links

                    if ($state.current && $state.current.name === 'checkout.payWithSelection') {
                        return true;
                    }
                    return !$scope.showVenmoLegalLinks;
                };
            }
        };
    });
});

_index.$ReturnToMerchant;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutPayeeModel;


//////////////////
// WEBPACK FOOTER
// ./components/xo-page-components/src/footer/directive.js
// module id = ./components/xo-page-components/src/footer/directive.js
// module chunks = 1